import moment from 'moment'

const datePickerPastBlocker = (existingDate = null) => {
  const today = moment().startOf('day')
  const allowsPast = !!existingDate && moment(existingDate).isBefore(today)

  const pastBlockProps = allowsPast
    ? {}
    : {
        disablePast: true,
        minDate: today,
        minDateMessage: 'A data não pode ser no passado',
      }

  return { allowsPast, pastBlockProps }
}

export default datePickerPastBlocker
